var _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAi(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "url(#paint6_linear_1455_152)",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.875 6.25C0.875 6.25 0.875 5.21447 1.60723 4.48223C1.60723 4.48223 2.33947 3.75 3.375 3.75H14.625C14.625 3.75 15.6605 3.75 16.3928 4.48223C16.3928 4.48223 17.125 5.21446 17.125 6.25V15C17.125 15 17.125 16.0355 16.3928 16.7678C16.3928 16.7678 15.6605 17.5 14.625 17.5H3.375C3.375 17.5 2.33946 17.5 1.60723 16.7678C1.60723 16.7678 0.875 16.0355 0.875 15V6.25ZM2.125 6.25L2.125 15C2.125 15 2.125 15.5178 2.49112 15.8839C2.49112 15.8839 2.85723 16.25 3.375 16.25H14.625C14.625 16.25 15.1428 16.25 15.5089 15.8839C15.5089 15.8839 15.875 15.5178 15.875 15V6.25C15.875 6.25 15.875 5.73223 15.5089 5.36612C15.5089 5.36612 15.1428 5 14.625 5H3.375C3.375 5 2.85723 5 2.49112 5.36612C2.49112 5.36612 2.125 5.73223 2.125 6.25Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4 12.8125C4 12.8125 4 11.9064 4.6407 11.2657C4.6407 11.2657 5.28141 10.625 6.1875 10.625H11.8125C11.8125 10.625 12.7186 10.625 13.3593 11.2657C13.3593 11.2657 14 11.9064 14 12.8125C14 12.8125 14 13.7186 13.3593 14.3593C13.3593 14.3593 12.7186 15 11.8125 15H6.1875C6.1875 15 5.28141 15 4.6407 14.3593C4.6407 14.3593 4 13.7186 4 12.8125ZM5.25 12.8125C5.25 12.8125 5.25 13.2008 5.52459 13.4754C5.52459 13.4754 5.79917 13.75 6.1875 13.75H11.8125C11.8125 13.75 12.2008 13.75 12.4754 13.4754C12.4754 13.4754 12.75 13.2008 12.75 12.8125C12.75 12.8125 12.75 12.4242 12.4754 12.1496C12.4754 12.1496 12.2008 11.875 11.8125 11.875H6.1875C6.1875 11.875 5.79917 11.875 5.52459 12.1496C5.52459 12.1496 5.25 12.4242 5.25 12.8125Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.9375 11.25V14.375C9.9375 14.7202 10.2173 15 10.5625 15C10.9077 15 11.1875 14.7202 11.1875 14.375V11.25C11.1875 10.9048 10.9077 10.625 10.5625 10.625C10.2173 10.625 9.9375 10.9048 9.9375 11.25Z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M6.8125 11.25V14.375C6.8125 14.7202 7.09232 15 7.4375 15C7.78268 15 8.0625 14.7202 8.0625 14.375V11.25C8.0625 10.9048 7.78268 10.625 7.4375 10.625C7.09232 10.625 6.8125 10.9048 6.8125 11.25Z"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M9.625 4.375V1.25C9.625 0.904822 9.34518 0.625 9 0.625C8.65482 0.625 8.375 0.904822 8.375 1.25V4.375C8.375 4.72018 8.65482 5 9 5C9.34518 5 9.625 4.72018 9.625 4.375Z"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.5 8.4375C6.5 8.95523 6.08027 9.375 5.5625 9.375C5.04473 9.375 4.625 8.95523 4.625 8.4375C4.625 7.91977 5.04473 7.5 5.5625 7.5C6.08027 7.5 6.5 7.91977 6.5 8.4375Z"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M13.375 8.4375C13.375 8.95523 12.9553 9.375 12.4375 9.375C11.9197 9.375 11.5 8.95523 11.5 8.4375C11.5 7.91977 11.9197 7.5 12.4375 7.5C12.9553 7.5 13.375 7.91977 13.375 8.4375Z"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1455_152",
    x1: 21.6926,
    y1: 15.9283,
    x2: 2.19529,
    y2: 8.697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD3707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4A1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1455_152",
    x1: 21.6926,
    y1: 15.9283,
    x2: 2.19529,
    y2: 8.697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD3707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4A1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_1455_152",
    x1: 21.6926,
    y1: 15.9283,
    x2: 2.19529,
    y2: 8.697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD3707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4A1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_1455_152",
    x1: 21.6926,
    y1: 15.9283,
    x2: 2.19529,
    y2: 8.697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD3707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4A1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_1455_152",
    x1: 21.6926,
    y1: 15.9283,
    x2: 2.19529,
    y2: 8.697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD3707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4A1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint5_linear_1455_152",
    x1: 21.6926,
    y1: 15.9283,
    x2: 2.19529,
    y2: 8.697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD3707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4A1E"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint6_linear_1455_152",
    x1: 21.6926,
    y1: 15.9283,
    x2: 2.19529,
    y2: 8.697,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FD3707"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF4A1E"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAi);
export default __webpack_public_path__ + "static/media/AI.df11f8ff1a9c0e4f6ee71443edcd4af3.svg";
export { ForwardRef as ReactComponent };